import { createRegion, updateRegion as editRegion, getRegions } from '../utils/apiService';

export const CREATE_REGION = 'region/CREATE_REGION';
export const CREATE_REGION_PENDING = 'region/CREATE_REGION_PENDING';
export const CREATE_REGION_FULFILLED = 'region/CREATE_REGION_FULFILLED';
export const CREATE_REGION_REJECTED = 'region/CREATE_REGION_REJECTED';

export const LIST_REGIONS = 'region/LIST_REGIONS';
export const LIST_REGIONS_PENDING = 'region/LIST_REGIONS_PENDING';
export const LIST_REGIONS_REJECTED = 'region/LIST_REGIONS_REJECTED';
export const LIST_REGIONS_FULFILLED = 'region/LIST_REGIONS_FULFILLED';

export const UPDATE_REGION = 'region/UPDATE_REGION';
export const UPDATE_REGION_PENDING = 'region/UPDATE_REGION_PENDING';
export const UPDATE_REGION_FULFILLED = 'region/UPDATE_REGION_FULFILLED';
export const UPDATE_REGION_REJECTED = 'region/UPDATE_REGION_REJECTED';


export const saveRegion = (region) => {
    const payload = createRegion(region);
    return {
        type: CREATE_REGION,
        payload
    }
}

export const updateRegion = (region) => {
    const payload = editRegion(region);
    return {
        type: UPDATE_REGION,
        payload
    }
}

export const listRegions = (filter) => {
    const payload = getRegions(filter);
    return {
        type: LIST_REGIONS,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/regions.js